// styles.ts
import { Theme } from "@mui/material";
import theme from "../../theme";
import {colorCodes} from "../../data/colors";

/** Root Drawer styling */
export const drawerSx = (t: Theme, open: boolean) => {
    return {
        width: open ? t.spacing(35) : t.spacing(12),
        display: "flex",
        "& .MuiDrawer-paper": {
            overflow: "visible",
            zIndex: theme.zIndex.appBar - 1,
            transition: t.transitions.create("width"),
            position: "relative",
            top: 0,
            alignSelf: "flex-start",
            height: "100%",
            p: 1,
            backgroundColor: colorCodes.intelliDarkerGreen,
            // backgroundColor: t.palette.primary.dark,
            marginRight: theme.spacing(3),
            paddingRight: 0,
        },
    };
};

export const hamburgerButtonSx = (t: Theme, open: boolean) => ({
    transition: "none",
    borderRadius: "initial",
    display: "block",
    textAlign: open ? "left" : "center",
    "&:hover": {
        backgroundColor: "initial",
    },

    '&:hover svg': {
        fill: t.palette.primary.contrastText,
    },
});

export const hamburgerIconSx = (open: boolean) => ({
    justifyContent: "center",
    transform: open ? "rotate(90deg)" : "none",
    fill: theme.palette.primary.main,
    background: "none",
    fontSize: "2rem",
});

/** Navigation row (list item button) */
export const navRowSx = (t: Theme, open: boolean) => ({
    // borderRadius: t.shape.borderRadius,
    justifyContent: open ? "left" : "center",
    borderBottom: open ? `1px solid ${t.palette.secondary.main}` : "none",
    marginLeft: "2rem",
    marginRight: 0,
    boxSizing: "border-box",
    "&.Mui-selected": {
        backgroundColor: "none",
        background: "none",
        textColor: t.palette.primary.main,
    },
    "&.Mui-selected:hover": {
        background: "inherit"
    },
    "&:hover .MuiTypography-root": {
        color: t.palette.primary.main, // or whatever color
    }
});

export const navRowTextSx = (t: Theme, open: boolean) => ({
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    display: open ? "block" : "none",
    ml: open ? 1 : 0,
})

export const toolIconContainerSx = {justifyContent: "center", minWidth: 0};
